import {
    useIsAuthenticated
} from '@azure/msal-react'
import { Footer } from 'components/Footer'
import NavBar from 'components/NavBar'
import { ROUTES_NAMES } from 'constants/name.routes'
import { Configurations } from 'pages/Configurations'
import { FormUser } from 'pages/Configurations/FormUser'
import { UnitySectors } from 'pages/Configurations/UnitySectors'
import Page from 'pages/Dev'
import { Login } from 'pages/Login'
import Notifications from 'pages/Notifications'
import { FormAccountabilityMatrix } from 'pages/NotificationTreatment/NotificationsTreatmentsSteps/AccountabilityMatrix/form'
import { FormIshikawa } from 'pages/NotificationTreatment/NotificationsTreatmentsSteps/IshikawaDiagram/form'
import FormLondonVersioned from 'pages/NotificationTreatment/NotificationsTreatmentsSteps/LondonProtocol/Version/Form'
import { ActionForm } from 'pages/NotificationTreatment/NotificationsTreatmentsSteps/ActionPlan/form'
import { GroupActionForm } from 'pages/NotificationTreatment/GroupTreatmentsSteps/GroupActionPlan/form'
import { GroupIshikawaForm } from 'pages/NotificationTreatment/GroupTreatmentsSteps/GroupIshikawaDiagram/form'
import { GroupLondonProtocolForm } from 'pages/NotificationTreatment/GroupTreatmentsSteps/GroupLondonProtocol/form'
import { GroupAccountabilityMatrixForm } from 'pages/NotificationTreatment/GroupTreatmentsSteps/GroupAccountabilityMatrix/form'
import { NotifyEvent } from 'pages/NotifyEvent'
import { NotifyEventPatient } from 'pages/NotifyEventPatient'
import Report from 'pages/Report'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import {
    BrowserRouter,
    Navigate,
    Route,
    Routes
} from 'react-router-dom'
import { AuthenticationReducer } from 'types/autentication'
import { RootReducerState } from 'types/global'
import NotificationView from 'pages/NotificationView'
import NotificationTreatment from 'pages/NotificationTreatment/NotificationTreatment'

const RoutesNotifica: React.FC = () => {

    const isCypressAuthenticated = () => {
        try {
            return sessionStorage.getItem('test.cypress.authenticated') === 'true';
        } catch {
            return false;
        }
    };


    const sessionCypressProfile: string | null = sessionStorage.getItem('test.cypress.profile')

    const authenticationSelector: AuthenticationReducer = useSelector(
        (state: RootReducerState) => state.authenticationReducers
    )

    const [currentProfile, setCurrentProfile] = useState<string>(null)

    const isAuthenticated = useIsAuthenticated()

    const isNotificaRedeAutenticated = (): boolean => {
        return isAuthenticated &&
            !authenticationSelector.azureAccessTokenExpired &&
            !authenticationSelector.jwtAccessTokenExpired ||
            isCypressAuthenticated()
    }

    const NavBarHandler = () => {
        return <>{<NavBar />}</>
    }

    const documentationStyle: React.CSSProperties = {
        position: 'fixed',
        color: 'white',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        width: '100%',
        height: '100%',
        border: 'none',
        margin: 0,
        padding: 0,
        zIndex: 99999999,
        overflowX: 'hidden'
    }
    /**
     * Usado para restrinigir o acesso as taelas de configurações perfis não autoruizados
     * @param param0 
     * @returns 
     */
    const ProfileAuthConfigurations = ({ children }) => {
        return currentProfile === 'admin' ||
            currentProfile === 'corporate_quality_management' ||
            currentProfile === 'corporate_quality_board' ? children : <Navigate to="/" replace />;
    }
    /**
     * Renderiza a tela de login caso o usuario não esteja logado ou acessToken expirado
     * @param props 
     * @returns 
     */
    const AutenticatedRoute = (props) => {
        return (
            <React.Fragment>
                {
                    isNotificaRedeAutenticated() ? props.children : <Login />
                }
            </React.Fragment>
        )
    }

    useEffect(() => {
        setCurrentProfile(authenticationSelector.dataJwt ? authenticationSelector.dataJwt.profile : null)
    }, [authenticationSelector.dataJwt])

    useEffect(() => {
        if (isCypressAuthenticated())
            setCurrentProfile(sessionCypressProfile)
    }, [])

    return (
        <div className='min-h-screen flex flex-col justify-between'>
            <BrowserRouter>
                <NavBarHandler />
                <Routes>
                    <Route path={ROUTES_NAMES.documentation}
                        element={
                            <AutenticatedRoute>
                                <iframe
                                    src={`${process.env.REACT_APP_DEV_DOCUMENTATION_URL}?random=${(new Date()).getTime() + Math.floor(Math.random() * 1000000)}`}
                                    style={documentationStyle}></iframe>
                            </AutenticatedRoute>
                        } />
                    <Route index path={'/'}
                        element={
                            <AutenticatedRoute>
                                <Notifications />
                            </AutenticatedRoute>
                        } />
                    <Route index path={ROUTES_NAMES.login} element={<Navigate to={'/'} replace />} />
                    <Route
                        path={ROUTES_NAMES.reports}
                        element={
                            <AutenticatedRoute>
                                <Report />
                            </AutenticatedRoute>
                        } />
                    <Route
                        path={ROUTES_NAMES.exportReport}
                        element={
                            <AutenticatedRoute>
                                <Report />
                            </AutenticatedRoute>
                        } />
                    <Route
                        path={ROUTES_NAMES.notifications}
                        element={
                            <AutenticatedRoute>
                                <Notifications />
                            </AutenticatedRoute>
                        } />
                    <Route
                        path={`${ROUTES_NAMES.notifications}/dev`}
                        element={
                            <AutenticatedRoute>
                                <Page />
                            </AutenticatedRoute>
                        } />
                    <Route
                        path={`${ROUTES_NAMES.notifications}/:id`}
                        element={
                            <AutenticatedRoute>
                                <NotificationTreatment />
                            </AutenticatedRoute>
                        } />

                    <Route
                        path={`${ROUTES_NAMES.notifications}/group-treatment/:groupId`}
                        element={
                            <AutenticatedRoute>
                                <NotificationTreatment />
                            </AutenticatedRoute>
                        } />

                    <Route
                        path={`${ROUTES_NAMES.notifications}/view-group`}
                        element={
                            <AutenticatedRoute>
                                <NotificationView />
                            </AutenticatedRoute>
                        } />

                    <Route
                        path={`${ROUTES_NAMES.notifications}/analise_ishikawa/:id`}

                        element={
                            <AutenticatedRoute>
                                <FormIshikawa />
                            </AutenticatedRoute>
                        } />
                    <Route path={`${ROUTES_NAMES.notifications}/accountability_matrix/:id`}
                        element={
                            <AutenticatedRoute>
                                <FormAccountabilityMatrix />
                            </AutenticatedRoute>
                        } />
                    <Route
                        path={`${ROUTES_NAMES.notifications}/london_protocol/:id`}
                        element={<AutenticatedRoute><FormLondonVersioned /></AutenticatedRoute>}
                    />
                    <Route
                        path={`${ROUTES_NAMES.notifications}/action_plan/:id`}
                        element={<AutenticatedRoute><ActionForm /></AutenticatedRoute>}
                    />
                    <Route
                        path={`${ROUTES_NAMES.notifications}/group_action_plan/:id`}
                        element={<AutenticatedRoute><GroupActionForm /></AutenticatedRoute>}
                    />
                    <Route
                        path={`${ROUTES_NAMES.notifications}/group_ishikawa/:id`}
                        element={<AutenticatedRoute><GroupIshikawaForm /></AutenticatedRoute>}
                    />
                    <Route
                        path={`${ROUTES_NAMES.notifications}/group_london_protocol/:id`}
                        element={<AutenticatedRoute><GroupLondonProtocolForm /></AutenticatedRoute>}
                    />
                    <Route
                        path={`${ROUTES_NAMES.notifications}/group_accountability_matrix/:id`}
                        element={<AutenticatedRoute><GroupAccountabilityMatrixForm /></AutenticatedRoute>}
                    />
                    <Route
                        path={ROUTES_NAMES.notifyEvent}
                        element={<NotifyEvent />}
                    />
                    <Route
                        path={ROUTES_NAMES.notifySent}
                        element={<NotifyEvent />}
                    />
                    <Route
                        path={ROUTES_NAMES.notifyEventPatient}
                        element={<NotifyEventPatient />}
                    />
                    <Route
                        path={ROUTES_NAMES.notifySentPatient}
                        element={<NotifyEventPatient />}
                    />
                    <Route
                        path={ROUTES_NAMES.configurationsRoutes.configurations}
                        element={<AutenticatedRoute><ProfileAuthConfigurations><Configurations /></ProfileAuthConfigurations></AutenticatedRoute>}
                    >
                        <Route
                            path={ROUTES_NAMES.configurationsRoutes.users}
                            element={<AutenticatedRoute><Configurations /></AutenticatedRoute>}
                        />
                        <Route
                            path={ROUTES_NAMES.configurationsRoutes.newUser}
                            element={<AutenticatedRoute><FormUser /></AutenticatedRoute>}
                        />
                        <Route
                            path={`${ROUTES_NAMES.configurationsRoutes.accessUser}/:id`}
                            element={<AutenticatedRoute><FormUser /></AutenticatedRoute>}
                        />
                    </Route>
                    <Route
                        path={
                            ROUTES_NAMES.configurationsRoutes.configurationsSectors
                        }
                        element={<AutenticatedRoute><Configurations /></AutenticatedRoute>}
                    />
                    <Route
                        path={
                            ROUTES_NAMES.configurationsRoutes.configurationsUnities
                        }
                        element={<AutenticatedRoute><Configurations /></AutenticatedRoute>}
                    />
                    <Route
                        path={
                            `${ROUTES_NAMES.configurationsRoutes.configurationsUnities}/:id`
                        }
                        element={<AutenticatedRoute><UnitySectors /></AutenticatedRoute>}
                    />
                    <Route
                        path={`${ROUTES_NAMES.configurationsRoutes.editSectors}/:id`}
                        element={<AutenticatedRoute><Configurations /></AutenticatedRoute>}
                    />
                    <Route
                        path="/"
                        element={<Navigate to={'/'} replace />}
                    />
                </Routes>
                <Footer />
            </BrowserRouter>
        </div>
    )
}

export default RoutesNotifica